import { render, staticRenderFns } from "./UpdateResourceDialog.vue?vue&type=template&id=46ba1c26&scoped=true"
import script from "./UpdateResourceDialog.vue?vue&type=script&lang=js"
export * from "./UpdateResourceDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateResourceDialog.vue?vue&type=style&index=0&id=46ba1c26&prod&scoped=true&lang=css"
import style1 from "./UpdateResourceDialog.vue?vue&type=style&index=1&id=46ba1c26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba1c26",
  null
  
)

export default component.exports